// We iterate over these colors if needed (Widgets/Purple,Turquoise, Gold, Blue, Pink, Emrald, Neutral)
export const salesPipelineColors = [
  { stroke: "#867cf8", fill: "#272261" },
  { stroke: "#35B0A5", fill: "#13403E" },
  { stroke: "#EC9D16", fill: "#4D3917" },
  { stroke: "#3366FF", fill: "#142966" },
  { stroke: "#EE38D0", fill: "#661458" },
  { stroke: "#2FEAA5", fill: "#1A7A59" },
  { stroke: "#475467", fill: "#1D2433" }
];

export const avatarColorIndex = (index: number) =>
  index % salesPipelineColors.length;
